module.exports = __webpack_public_path__ + "static/media/star-wars.d0504dc3.jpg";